import { IBrand } from '../../../interfaces/Brand.interfaces';
import { customAxios } from '../../common/customAxios';

export const getBrands = (): Promise<IBrand[]> => {
  return customAxios.get('/brands');
};
